<template>
    <div>
        <h1 class="display-heading">Invoices</h1>
        <div class="card mb-3">
            <div class="card-body">
                <div class="form-group mr-3 d-flex align-items-baseline">
                    <label class="mr-2 font-weight-bold">View Invoices by Month:</label>
                    <select style="width: 200px" class="form-control" v-model="viewMonthSelect">
                        <option v-for="(option, index) in monthsDropdown" :key="index" :value="option===null ? null : option">
                            {{ option === null ? "All Time" : getMonthYearDisplay(option) }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="50">
                        <col width="200">
                        <col >
                        <col width="150">
                        <col width="150">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Invoice Date</th>
                            <th scope="col">Invoice No.</th>
                            <th scope="col" class="text-right pr-3">Amount (RM)</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="invoiceList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>

                        <tr v-for="(invoice, index) in invoiceList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td>
                                {{ invoice.dateDisplay }}
                            </td>
                            <td class="text-nowrap">
                                {{ invoice.isEmpty ? 'No invoice' : invoice.invoiceNo }}
                            </td>
                            <td class="text-right pr-3">
                                {{ invoice.amount }}
                            </td>
                            <td class="text-nowrap">
                                <router-link v-if="!invoice.isEmpty" :to="{
                                    'name': 'view-invoice',
                                    'params': {
                                        'id': invoice.invoiceId
                                    }
                                }" target="_blank">View / Edit</router-link>
                                <span v-else>-</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDate
} from '@/utilities';
import moment from 'moment';
import pagination from '@/components/pagination';
export default {
    'name': 'CompanyInvoices',
    'components': {
        pagination
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'monthsDropdown': [],
            'viewMonthSelect': null,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'invoiceList': []
        };
    },
    mounted () {
        this.getMonthsDropdown();
        this.getMonthInvoice(null);

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });
    },
    'watch': {
        viewMonthSelect (val) {
            this.pagination.currentPage = 1;
            this.getMonthInvoice(val);
        },
        currentPage () {
            this.$nextTick(() => {
                this.getMonthInvoice(this.viewMonthSelect);
            });
        }
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'methods': {
        getMonthsDropdown () {
            this.axios.get('company/GetMonthsDropdown', {
                'params': {
                    'orderByDescending': true
                }
            }).then(({ data }) => {
                this.monthsDropdown = [];
                this.monthsDropdown.push(null);
                this.monthsDropdown.push(...data.data);
            });
        },
        getMonthYearDisplay (iso8601DateTimeString) {
            let momentInstance = moment(iso8601DateTimeString);

            return momentInstance.format('MMMM YYYY');
        },
        getMonthInvoice (selection) {
            this.isTableLoading = true;
            this.axios.post('Invoice/GetFilteredInvoices', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'm': selection
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.invoiceList = list.map((invoice) => ({
                    'amount': invoice.totalAmount.toFixed(2),
                    'invoiceId': invoice.invoiceId,
                    'dateDisplay': convertToUserReadableDate(invoice.documentDate),
                    'invoiceNo': invoice.documentNumber,
                    'isEmpty': invoice.isEmpty
                }));
            });
        }
    }
};
</script>
